module.exports = __webpack_public_path__ + "static/img/btn_2.309d34e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_2.png
// module id = JZUM
// module chunks = 1